import script from "./FilterDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./FilterDropdown.vue?vue&type=style&index=0&id=2f3e95c1&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3e95c1"]])

export default __exports__